export default "__VITE_ASSET__CyRPltyX__"